import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e94a463c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-frame" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { style: {"margin-top":"15px","text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#acbfd2","font-size":"11px"} }, " Copyright 2022. Jin solutions Co., Ltd. All rights reserved. ", -1))

import { ref, watchEffect } from "vue";
import { loginService } from "../service/account.service";
import AppImage from "@/components/AppImage.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = ref({
  message: "",
  loginState: false,
  btnMargin: 30,
});

const loginUser = ref({
  loginId: "",
  loginPwd: "",
});

const goLogin = async (loginId: string, loginPwd: string) => {
  const msg = await loginService(loginId, loginPwd);
  state.value.message = msg;
  if (msg) {
    state.value.loginState = true;
    loginUser.value.loginId = "";
    loginUser.value.loginPwd = "";
    setTimeout(() => {
      state.value.loginState = false;
    }, 3000);
  } else {
    loginUser.value.loginId = "";
    loginUser.value.loginPwd = "";
  }
};

watchEffect(() => {
  if (state.value.loginState) {
    state.value.btnMargin = 7;
  } else {
    state.value.btnMargin = 30;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppImage, {
      name: "background_login",
      style: {"width":"100%"}
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppImage, {
        class: "logo-img",
        name: "logo2"
      }),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (goLogin(loginUser.value.loginId, loginUser.value.loginPwd)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "login-box-id",
          type: "text",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginUser.value.loginId) = $event)),
          placeholder: "ID",
          autofocus: ""
        }, null, 512), [
          [_vModelText, loginUser.value.loginId]
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "login-box-pwd",
          type: "password",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginUser.value.loginPwd) = $event)),
          placeholder: "PW"
        }, null, 512), [
          [_vModelText, loginUser.value.loginPwd]
        ]),
        _withDirectives(_createElementVNode("div", { class: "login-err-msg" }, _toDisplayString(state.value.message), 513), [
          [_vShow, state.value.loginState]
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            disabled: loginUser.value.loginId === '' || loginUser.value.loginPwd === '',
            style: _normalizeStyle({ marginTop: `${state.value.btnMargin}px` }),
            class: "login-box-btn"
          }, " Login ", 12, _hoisted_3)
        ])
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppImage, {
          name: "logo",
          style: {"width":"100px","height":"10px"}
        }),
        _hoisted_5
      ])
    ])
  ]))
}
}

})